import { enumToArray } from 'utils/other';
import { Box } from '@material-ui/core';
import { FilterButtonSwitcher } from 'components/app-grid';
import React from 'react';
import { useTranslate } from 'hooks/use-translate';
import { ASSIGNED } from '../../helpers';
import { IDataGridFilter } from 'components/data-grid/model';

interface Props {
  filter: IDataGridFilter;
  onTasks: any;
  value: ASSIGNED;
}

export const FilterAssign: React.FC<Props> = (props) => {
  const { t } = useTranslate();

  const options = enumToArray(ASSIGNED).map((item) => ({
    ...item,
    value: item.id,
    title: t(item.id),
  }));
  return (
    <Box mx={1} display="flex" flexGrow={1}>
      <Box ml="auto">
        <FilterButtonSwitcher {...props} options={options} />
      </Box>
    </Box>
  );
};
